/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { SkillsControllerFindOneQueryResponse, SkillsControllerFindOnePathParams, SkillsControllerFindOne400, SkillsControllerFindOne401, SkillsControllerFindOne403, SkillsControllerFindOne404 } from "../../models/skillsController/SkillsControllerFindOne";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { skillsControllerFindOne } from "../../clients/skillsService/skillsControllerFindOne";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const skillsControllerFindOneQueryKey = (id: SkillsControllerFindOnePathParams["id"]) => [{
  url: '/api/v1/skills/:id',
  params: {
    id: id
  }
}] as const;
export type SkillsControllerFindOneQueryKey = ReturnType<typeof skillsControllerFindOneQueryKey>;
export function skillsControllerFindOneQueryOptions(id: SkillsControllerFindOnePathParams["id"], config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = skillsControllerFindOneQueryKey(id);
  return queryOptions<SkillsControllerFindOneQueryResponse, ResponseErrorConfig<SkillsControllerFindOne400 | SkillsControllerFindOne401 | SkillsControllerFindOne403 | SkillsControllerFindOne404>, SkillsControllerFindOneQueryResponse, typeof queryKey>({
    enabled: !!id,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return skillsControllerFindOne(id, config);
    }
  });
}

/**
 * @summary Get a visible skill with live S3 files
 * {@link /api/v1/skills/:id}
 */
export function useSkillsControllerFindOne<TData = SkillsControllerFindOneQueryResponse, TQueryData = SkillsControllerFindOneQueryResponse, TQueryKey extends QueryKey = SkillsControllerFindOneQueryKey>(id: SkillsControllerFindOnePathParams["id"], options: {
  query?: Partial<QueryObserverOptions<SkillsControllerFindOneQueryResponse, ResponseErrorConfig<SkillsControllerFindOne400 | SkillsControllerFindOne401 | SkillsControllerFindOne403 | SkillsControllerFindOne404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? skillsControllerFindOneQueryKey(id);
  const query = useQuery({
    ...skillsControllerFindOneQueryOptions(id, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<SkillsControllerFindOne400 | SkillsControllerFindOne401 | SkillsControllerFindOne403 | SkillsControllerFindOne404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}